package app.properties

import kotlin.js.Date

class CompanyType(
        val id: String,
        val name: String
)

class CompanyDirector(var firstname: String = "",
                      var lastname: String = "",
                      var parentName: String = "")

class Company(
        var id: String? = null,
        var name: String = "",
        var hhvh: String = "",
        var address: String = "",
        var workingTime: Int = 0,
        var createDate: String = "",
        var staffCount: Int? = null,
        var companyType: CompanyType? = null,
        var companyDirector: CompanyDirector = CompanyDirector(),
        var birthDay: String? = null
) {
    fun isValid() : Boolean {

        val hvhhRegex = Regex("^([0-9]{8})+$")

        return (name != "" &&
                (hhvh != "" && hvhhRegex.containsMatchIn(hhvh)) &&
                address != "" &&
                workingTime > 0 &&
                createDate != "" &&
                staffCount != null &&
                companyDirector.firstname != "" &&
                companyDirector.lastname != "" &&
                companyDirector.parentName != "" &&
                companyType != null)
    }
}
